import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  // {
  //   path: "/operationsManage",
  //   name: authCodeMap.operationsManage,
  //   component: (): any => import("@/modules/router.vue"),
  //   meta: {
  //     title: "运营管理",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.operationsManage,
  //   },
  //   children: [
  //     {
  //       path: authCodeMap.operationsManage_postBar_topic,
  //       name: authCodeMap.operationsManage_postBar_topic,
  //       component: (): any => import("@/modules/operationsManage/pages/postBar/topic.vue"),
  //       meta: {
  //         title: "运营_圈子管理_话题",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationsManage_postBar_topic,
  //       },
  //     },
  //     {
  //       path: authCodeMap.operationsManage_postBar_post,
  //       name: authCodeMap.operationsManage_postBar_post,
  //       component: (): any => import("@/modules/operationsManage/pages/postBar/index.vue"),
  //       meta: {
  //         title: "运营_圈子管理_圈子论坛",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationsManage_postBar_post,
  //       },
  //     },
  //     // {
  //     //   path: "postBar",
  //     //   name: authCodeMap.operationsManage_postBar,
  //     //   component: (): any => import("@/modules/operationsManage/pages/postBar/index.vue"),
  //     //   meta: {
  //     //     title: "运营管理_圈子论坛",
  //     //     hidden: true,
  //     //     needLogin: true,
  //     //     authCode: authCodeMap.operationsManage_postBar,
  //     //   },
  //     // },
  //     {
  //       path: "postBarEdit",
  //       name: authCodeMap.operationsManage_postBar_editPost,
  //       component: (): any => import("@/modules/operationsManage/pages/postBar/edit.vue"),
  //       meta: {
  //         title: "运营_圈子管理_帖子",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationsManage_postBar_editPost,
  //       },
  //     },
  //     {
  //       path: authCodeMap.operationManage_advertManage_manage,
  //       name: authCodeMap.operationManage_advertManage_manage,
  //       component: (): any => import("@/modules/operationsManage/pages/advertManage/components/advertConfig/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "运营_运营位管理_运营位配置",
  //         authCode: authCodeMap.operationManage_advertManage_manage,
  //       },
  //     },
  //     {
  //       path: authCodeMap.operationManage_advertManage_data,
  //       name: authCodeMap.operationManage_advertManage_data,
  //       component: (): any => import("@/modules/operationsManage/pages/advertManage/components/advertData/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "运营_运营位管理_运营位数据",
  //         authCode: authCodeMap.operationManage_advertManage_data,
  //       },
  //     },
  //     // {
  //     //   path: "advertManage",
  //     //   name: authCodeMap.operationManage_advertManage,
  //     //   component: (): any => import("@/modules/operationsManage/pages/advertManage/index.vue"),
  //     //   meta: {
  //     //     needLogin: true,
  //     //     title: "运营管理_运营位管理",
  //     //   },
  //     // },
  //     {
  //       path: "siteMsg",
  //       name: authCodeMap.operationsManage_siteMsg,
  //       component: (): any => import("@/modules/operationsManage/pages/siteMsg/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "运营_站内信管理",
  //       },
  //     },
  //     {
  //       path: "integralSet",
  //       name: authCodeMap.operationManage_integralSet,
  //       component: (): any => import("@/modules/operationsManage/pages/integralSet/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_积分设置",
  //         authCode: authCodeMap.operationManage_integralSet,
  //       },
  //     },
  //     {
  //       path: authCodeMap.operationManage_integralSet_setting,
  //       name: authCodeMap.operationManage_integralSet_setting,
  //       component: (): any => import("@/modules/operationsManage/pages/integralSet/ruleSetting.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_规则设置",
  //         authCode: authCodeMap.operationManage_integralSet_setting,
  //       },
  //     },
  //     {
  //       path: "userPoint",
  //       name: authCodeMap.operationManage_integralSet_userIntegral,
  //       component: (): any => import("@/modules/operationsManage/pages/integralSet/components/userIntegral.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_用户积分(积分设置)",
  //         authCode: authCodeMap.operationManage_integralSet_userIntegral,
  //       },
  //     },
  //     {
  //       path: "pointManage",
  //       name: authCodeMap.operationManage_pointManage,
  //       component: (): any => import("@/modules/operationsManage/pages/pointManage/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_用户积分",
  //         authCode: authCodeMap.operationManage_pointManage,
  //       },
  //     },
  //     {
  //       path: "pointsMallEdit",
  //       name: authCodeMap.operationManage_pointsMallEdit,
  //       component: (): any => import("@/modules/operationsManage/pages/pointsMall/edit.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_积分商城编辑",
  //         authCode: authCodeMap.operationManage_pointsMallEdit,
  //       },
  //     },
  //     {
  //       path: "pointsMallList",
  //       name: authCodeMap.operationManage_pointsMallList,
  //       component: (): any => import("@/modules/operationsManage/pages/pointsMall/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_积分商城",
  //         authCode: authCodeMap.operationManage_pointsMallList,
  //       },
  //     },
  //     {
  //       path: "pointDetail",
  //       name: authCodeMap.operationManage_pointDetail,
  //       component: (): any => import("@/modules/operationsManage/pages/pointDetail/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "营销_积分管理_积分明细",
  //         authCode: authCodeMap.operationManage_pointDetail,
  //       },
  //     },
  //     {
  //       path: "voteManage",
  //       name: authCodeMap.activityManage_voteManage_index,
  //       component: (): any => import("@/modules/operationsManage/pages/voteManage/index.vue"),
  //       meta: {
  //         title: "运营管理_投票管理",
  //         // hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_voteManage_index,
  //       },
  //     },
  //   ],
  // },
];
export default routes;
